"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.filter = void 0;
const moment_1 = __importDefault(require("moment"));
// const FORMAT = 'hh:mm A';
const slots = () => {
    const start = (0, moment_1.default)().startOf('day');
    return [...new Array(12 * 4).keys()].map((_, idx) => (0, moment_1.default)(start)
        .add(15 * idx, 'minutes')
        .format('hh:mm'));
};
const inputFilter = (options) => (value, _period) => {
    if (!value) {
        return options;
    }
    return options;
    // const valueMoment = moment(`${value} ${period}`, FORMAT);
    // if (!valueMoment.isValid()) {
    //   return [];
    // }
    // return options.filter((o) => moment(`${o} ${period}`, FORMAT).isAfter(valueMoment));
};
exports.filter = inputFilter(slots());
